module.exports = {
  dark: 'dark',
  light: 'light',
};
